"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // TODO curry drawerWidth?


var drawerWidth = 240;

var styles = function styles(theme) {
  var _ref;

  return _ref = {
    layout: {
      display: 'flex',
      minHeight: '100vh',
      flexDirection: 'column'
    },
    appBar: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    appBarShift: {
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    appBarLeftShift: {
      marginLeft: drawerWidth,
      width: "calc(100% - ".concat(drawerWidth, "px)")
    },
    appBarRightShift: {
      marginRight: drawerWidth,
      width: "calc(100% - ".concat(drawerWidth, "px)")
    },
    appBarLeftRightShift: {
      marginLeft: drawerWidth,
      marginRight: drawerWidth,
      width: "calc(100% - ".concat(drawerWidth * 2, "px)")
    },
    main: {
      paddingTop: '0px',
      display: 'flex',
      width: '100%',
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    mainFixedAppBar: {
      marginTop: theme.mixins.toolbar.minHeight
    },
    mainFixedTwoRowAppBar: {
      marginTop: theme.mixins.toolbar.minHeight * 2
    },
    mainGrow: {
      flex: [[1, 0, 'auto']],
      minHeight: "calc(100vh - ".concat(theme.mixins.toolbar.minHeight, "px)")
    },
    mainGrowTwoRowAppBar: {
      flex: [[1, 0, 'auto']],
      minHeight: "calc(100vh - ".concat(theme.mixins.toolbar.minHeight * 2, "px)")
    },
    drawerHeader: theme.mixins.toolbar,
    drawerHeaderTwoRowAppBar: {
      minHeight: theme.mixins.toolbar.minHeight * 2
    }
  }, _defineProperty(_ref, theme.breakpoints.up('sm'), {
    mainFixedAppBar: {
      marginTop: theme.mixins.toolbar[theme.breakpoints.up('sm')].minHeight
    },
    mainFixedTwoRowAppBar: {
      marginTop: theme.mixins.toolbar[theme.breakpoints.up('sm')].minHeight * 2
    },
    mainGrow: {
      // eslint-disable-next-line prettier/prettier
      minHeight: "calc(100vh - ".concat(theme.mixins.toolbar[theme.breakpoints.up('sm')].minHeight, "px)")
    },
    mainGrowTwoRowAppBar: {
      minHeight: "calc(100vh - ".concat(theme.mixins.toolbar[theme.breakpoints.up('sm')].minHeight * 2, "px)")
    },
    drawerHeaderTwoRowAppBar: {
      minHeight: theme.mixins.toolbar[theme.breakpoints.up('sm')].minHeight * 2
    }
  }), _defineProperty(_ref, "mainStickyFooter", {
    flex: [[1, 0, 'auto']]
  }), _defineProperty(_ref, "mainShift", {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  }), _defineProperty(_ref, "mainLeftShift", {
    marginLeft: drawerWidth,
    width: "calc(100% - ".concat(drawerWidth, "px)")
  }), _defineProperty(_ref, "mainRightShift", {
    marginRight: drawerWidth,
    width: "calc(100% - ".concat(drawerWidth, "px)")
  }), _defineProperty(_ref, "mainLeftRightShift", {
    marginRight: drawerWidth,
    marginLeft: drawerWidth,
    width: "calc(100% - ".concat(drawerWidth * 2, "px)")
  }), _defineProperty(_ref, "drawerPaper", {
    width: drawerWidth
  }), _defineProperty(_ref, "drawerPaperUnder", {
    zIndex: '1000'
  }), _defineProperty(_ref, "footer", {}), _ref;
};

var _default = styles;
exports["default"] = _default;